import { render, staticRenderFns } from "./BaseChatMessage.vue?vue&type=template&id=6904df80&scoped=true&"
import script from "./BaseChatMessage.vue?vue&type=script&lang=js&"
export * from "./BaseChatMessage.vue?vue&type=script&lang=js&"
import style0 from "./BaseChatMessage.vue?vue&type=style&index=0&id=6904df80&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6904df80",
  null
  
)

export default component.exports